import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2b8a8da7"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "route-plan" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Koosta teekond", -1))
const _hoisted_3 = { key: 0 }
const _hoisted_4 = {
  key: 0,
  class: "route-plan__segment"
}
const _hoisted_5 = { key: 1 }
const _hoisted_6 = {
  key: 0,
  class: "route-plan__segment"
}
const _hoisted_7 = {
  key: 1,
  class: "route-plan__segment"
}

import { computed, PropType, Ref, ref, watch } from 'vue'
import { PublicService } from '@/models/public/bookingWidget.model'
import DatePicker from '@/components/DatePicker.vue'
import BaseAddressSearch from '@/components/BaseAddressSearch.vue'
import BaseIcon from '@/components/BaseIcon.vue'
import { Route } from '@/models/public/routePlanner.model'
import {
  useCreateRouteMutation,
  useUpdateRouteMutation,
} from '@/queries/public/services'
import BaseAutocomplete from '@/components/BaseAutocomplete.vue'
import { AddressDetailsPayload } from '@/models/location.model'
import { RelatedServiceLocation } from '@/models/public/service.model'
import { formatISO } from 'date-fns'
import {
  formatIntlDateAndTime,
  formatMinutesToDuration,
  formatServerDateTime,
} from '@/utils/formatters'
import RoutePlanStop from '@/components/public/route-planner/RoutePlanStop.vue'
import { calculateFinalDestinationETA } from '@/utils/route-planner'


export default /*#__PURE__*/_defineComponent({
  __name: 'RoutePlan',
  props: {
  route: {
    type: Object as PropType<Route | null>,
    default: null,
  },
},
  emits: [
  'onChange',
  'onSelect',
  'onRouteUpdate',
  'onRefresh',
],
  setup(__props, { emit: emits }) {

const props = __props



const defaultAddress = {
  city: '',
  country: '',
  county: '',
  google_address: '',
  latitude: '',
  longitude: '',
  number: '',
  street: '',
  zip_code: '',
}


const startTime = ref<Date | null>(new Date())
const startPoint = ref<AddressDetailsPayload>({ ...defaultAddress })
const endPoint = ref<AddressDetailsPayload>({ ...defaultAddress })

const { mutateAsync: updateRoute } = useUpdateRouteMutation()
const { mutateAsync: createRoute } = useCreateRouteMutation()

const finalDestinationEta = computed(() =>
  calculateFinalDestinationETA(props.route),
)

watch(
  () => props.route?.start_point,
  () => {
    handleUpdateDateFromProps(startPoint, props.route?.start_point)
  },
)

watch(
  () => props.route?.end_point,
  () => {
    handleUpdateDateFromProps(endPoint, props.route?.end_point)
  },
)

const handleUpdateDateFromProps = (
  value: Ref<AddressDetailsPayload>,
  prop?: RelatedServiceLocation | null,
) => {
  if (prop?.full_address && prop.full_address !== value.value.google_address) {
    value.value = {
      ...value.value,
      google_address: prop.full_address,
      latitude: prop.latitude_decimal_degree,
      longitude: prop.longitude_decimal_degree,
    }
  }
}

const handleCreateRoute = async () => {
  try {
    return await createRoute()
  } catch (e) {
    console.error(e)
  }
  return null
}

const handleUpdateRoute = async () => {
  let route = props.route
  if (!route) {
    route = await handleCreateRoute()
  }
  try {
    route = await updateRoute({
      route: route!.id,
      start_time: startTime.value ? formatISO(startTime.value) : null,
      start_point: startPoint.value,
      end_point: endPoint.value,
    })
    emits('onRouteUpdate', route)
  } catch (e) {
    console.error(e)
  }
}

const handleChangeStartTime = (value: Date | null) => {
  startTime.value = value
  handleUpdateRoute()
}

const handleChangeStartPoint = (value: AddressDetailsPayload) => {
  startPoint.value = value
  handleUpdateRoute()
}

const handleChangeEndPoint = (value: AddressDetailsPayload) => {
  endPoint.value = value
  handleUpdateRoute()
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(DatePicker, {
      "model-value": startTime.value,
      name: "start",
      label: _ctx.$t('start'),
      "enable-time-picker": "",
      "min-date": new Date(),
      "month-change-on-scroll": false,
      "month-change-on-arrows": false,
      "keep-action-row": "",
      flow: ['calendar', 'time'],
      "onUpdate:modelValue": _cache[0] || (_cache[0] = (value) => handleChangeStartTime(value))
    }, null, 8, ["model-value", "label", "min-date"]),
    _createVNode(BaseAddressSearch, {
      result: startPoint.value.google_address,
      placeholder: 'Alguspunkt',
      onOptionClick: _cache[1] || (_cache[1] = (value) => handleChangeStartPoint(value)),
      "onUpdate:modelValue": _cache[2] || (_cache[2] = (value) => (startPoint.value.google_address = value))
    }, null, 8, ["result"]),
    (__props.route?.stops?.length || __props.route?.segments?.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          (__props.route?.segments?.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createVNode(BaseIcon, {
                  icon: 'car',
                  size: 16
                }),
                _createTextVNode(" " + _toDisplayString(_unref(formatMinutesToDuration)(__props.route?.segments[0]?.duration_minutes)), 1)
              ]))
            : _createCommentVNode("", true),
          (__props.route?.stops?.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.route.stops, (stop, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: stop.id
                  }, [
                    _createVNode(RoutePlanStop, {
                      stop: stop,
                      route: __props.route,
                      onOnRefresh: () => emits('onRefresh', stop.service),
                      onOnDelete: () => emits('onDelete', stop),
                      onClick: () => emits('onSelect', stop.service)
                    }, null, 8, ["stop", "route", "onOnRefresh", "onOnDelete", "onClick"]),
                    (__props.route?.segments[index + 1])
                      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                          _createVNode(BaseIcon, {
                            icon: 'car',
                            size: 16
                          }),
                          _createTextVNode(" " + _toDisplayString(_unref(formatMinutesToDuration)(
                __props.route?.segments[index + 1]?.duration_minutes,
              )), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                }), 128))
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    _createVNode(BaseAddressSearch, {
      result: endPoint.value.google_address,
      placeholder: 'Lõpp-punkt',
      onOptionClick: _cache[3] || (_cache[3] = (value) => handleChangeEndPoint(value)),
      "onUpdate:modelValue": _cache[4] || (_cache[4] = (value) => (endPoint.value.google_address = value))
    }, null, 8, ["result"]),
    (_unref(finalDestinationEta))
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, " Eeldatav kohalejõudmine: " + _toDisplayString(_unref(formatIntlDateAndTime)(_unref(finalDestinationEta))), 1))
      : _createCommentVNode("", true)
  ]))
}
}

})